
function NotificationMessage() {
  const notificationCloseBtn = document.querySelector( 
    ".cart__notification__close-btn"
  );
  
  if (notificationCloseBtn) {
    notificationCloseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const notificationWrapper = document.querySelector(
        ".cart__notification-wrapper"
      ); 
      
      if (notificationWrapper) {
        notificationWrapper.style.display = "none";
      }
    });
  }
}



function getSelectedVariantPrice() {
  const selectEl = document.querySelector(".indiv-product__option-select");
  const variantPriceEls = document.querySelectorAll(
    ".indiv-product__price-wrapper"
  );

  variantPriceEls[0].style.display = "block";

  if (selectEl) {
    selectEl.addEventListener("change", (e) => {
      let selectedVariant = e.target.value;
      console.log("selectedVariant", selectedVariant);
      variantPriceEls.forEach((el) => {
        if (el.dataset.variantId === selectedVariant) {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      });  
    });
  }
}


NotificationMessage();
getSelectedVariantPrice()